import { COMPONENT_TYPES } from '../../../constants';
import RecommendedUsersComponent from './RecommendedUsers.component';
import RecommendedUsersEditor from './RecommendedUsers.editor';
import RecommendedUsersProperties from '../../propertyPanel/ComponentProperties/RecommendedUsersProperties';
import { registerSkinnableComponent, registerPropertyPanel } from '../registry';
import { RecommendedUsersSkinnable } from './RecommendedUsersSkinnable';

// 스킨 가능한 컴포넌트로 등록
registerSkinnableComponent(RecommendedUsersSkinnable);

// 속성 패널 등록
registerPropertyPanel(COMPONENT_TYPES.RECOMMENDED_USERS, RecommendedUsersProperties);

// 컴포넌트 타입 상수
export const COMPONENT_TYPE = 'RECOMMENDED_USERS';

// 컴포넌트 및 타입 내보내기
export { default as RecommendedUsersComponent } from './RecommendedUsers.component';
export { default as RecommendedUsersEditor } from './RecommendedUsers.editor';
export { default as RecommendedUsersProperties } from './RecommendedUsers.properties';
export * from './RecommendedUsers.types'; 